"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRefreshToken = void 0;
const useAuth_1 = require("./useAuth");
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const react_1 = require("react");
const useAuthTokens_1 = require("./useAuthTokens");
const auth_api_1 = require("../apis/auth.api");
const useRefreshToken = () => {
    const { logout } = (0, useAuth_1.useAuth)();
    const [accessTokenExpirationAt, setAccessTokenExpirationAt] = (0, react_1.useState)(undefined);
    const { authTokens, saveAuthTokens } = (0, useAuthTokens_1.useAuthTokens)();
    const refreshTokens = (refreshToken) => {
        const currentRefreshToken = refreshToken || authTokens?.refreshToken || '';
        return (0, auth_api_1.getRefreshAuthTokens)({ refreshToken: currentRefreshToken }).then(response => {
            saveAuthTokens({
                refreshToken: response.refreshToken || currentRefreshToken,
                accessToken: response.access_token
            });
            return response;
        }).catch(() => {
            logout();
            return undefined;
        });
    };
    (0, react_1.useEffect)(() => {
        setAccessTokenExpirationAt(authTokens?.accessToken ? getTokenExpirationDate(authTokens?.accessToken) : undefined);
    }, [authTokens?.accessToken]);
    const getTokenExpirationDate = (token) => {
        const jwtDecode = (0, jwt_decode_1.default)(token);
        return jwtDecode ? new Date(jwtDecode.exp * 1000) : undefined;
    };
    return {
        triggerRefreshTokens: refreshTokens,
        accessTokenExpirationAt,
        refreshToken: authTokens?.refreshToken
    };
};
exports.useRefreshToken = useRefreshToken;
